const widgets = {
  editMode: "Edit",
  guideMode: "Guide",
  library: "Widget Library",
  size: "Size",
  hoverDelay: "Hover Delay",
  none: "None",
  seconds: "seconds",
  showWidget: "Show",
  hideWidget: "Hide",
  comingSoon: "Coming Soon",
  noWidgets: "No active widgets",
  addWidgets: "Add Widgets",
  close: "Close",
  resetSize: "Reset Size",
  search: "Search",
  searchPlaceholder: "Search projects, documents...",
  recent: "Recent",
  recentSearches: "Recent searches",
  quickActions: "Quick Actions",
  newProject: "Create new project",
  newDocument: "New document",
  newTask: "New task",
  noResults: "No results",
  // Command Palette sections
  commandsSection: "Actions",
  pagesSection: "Pages",
  widgetsSection: "Widgets",
  projectsSection: "Projects",
  wikiSection: "Wiki",
  typeCommandHint: "Type > for commands, / for pages",
  // Apps Manager tab
  searchTab: "Search",
  appsTab: "Apps",
  appsOnToolbar: "On Toolbar",
  appsInDrawer: "In Apps",
  appsDisabled: "Disabled",
  appsAddToToolbar: "Add to Toolbar",
  appsRemoveFromToolbar: "Remove from Toolbar",
  appsMoveToApps: "Move to Apps",
  appsDisableWidget: "Disable Widget",
  appsActiveWidgets: "Active Widgets",
  appsAllWidgets: "All Widgets",
  appsComingSoon: "Coming Soon",
  projects: "Projects",
  documents: "Documents",
  conversations: "AI Conversations",
  aiAssistant: "AI Assistant",
  aiDescription: "Quick AI assistant with page context",
  ask: "Ask...",
  context: "Context",
  addContext: "Add context",
  sendMessage: "Send",
  typePlaceholder: "Ask a question...",
  suggestSummarize: "Summarize project status",
  suggestAttention: "What needs attention?",
  suggestWrite: "Help me write",
  suggestFix: "Fix errors",
  suggestSummarizeDoc: "Summarize document",
  suggestToday: "What's on today?",
  suggestNewProject: "Create new project",
  sidePanel: "Side Panel",
  miniWindow: "Mini Window",
  floatingChat: "Floating Chat",
  quickCreate: "Quick Create",
  quickCreateDesc: "Create a document or new entity",
  newEntity: "New Entity",
  new: "New",
  newDocAction: "New Document",
  newFormalDoc: "Formal Doc",
  newProjectAction: "New Project",
  newTaskAction: "New Task",
  create: "Create",
  titlePlaceholder: "Name...",
  createdToday: "Created today",
  favorites: "Favorites",
  favoritesDesc: "Saved pages and links",
  addFavorite: "Add favorite",
  pinPage: "Pin page",
  unpinPage: "Unpin page",
  noFavorites: "No favorites",
  todayWidget: "Today",
  todayDesc: "Meetings, deadlines & reminders",
  meetings: "Meetings",
  deadlines: "Deadlines",
  reminders: "Reminders",
  noEvents: "No events today",
  // Notifications
  notifications: "Notifications",
  notificationsDesc: "Notifications from projects, documents & AI",
  markAllRead: "Mark all read",
  noNotifications: "No notifications",
  unread: "unread",
  // Timer
  timer: "Timer",
  timerDesc: "Pomodoro timer for time management",
  timerWork: "Work",
  timerBreak: "Break",
  timerLongBreak: "Long Break",
  timerStart: "Start",
  timerPause: "Pause",
  timerReset: "Reset",
  timerSessions: "Sessions",
  // Clipboard
  clipboard: "Clipboard",
  clipboardDesc: "Recently copied items",
  clearAll: "Clear all",
  noClipboardItems: "No items",
  copied: "Copied",
  clipboardItems: "items",
  activeWidgets: "Active",
  comingSoonWidgets: "Coming Soon",
  // Keyboard Shortcuts
  keyboardShortcuts: "Keyboard Shortcuts",
  keyboardShortcutsDesc: "Keyboard shortcuts & action management",
  shortcutsSearch: "Search shortcuts...",
  shortcutsActive: "Active",
  shortcutsAll: "All",
  shortcutsNoResults: "No shortcuts found",
  shortcutsAddCustom: "Add Custom Shortcut",
  shortcutsEdit: "Edit",
  shortcutsDelete: "Delete",
  shortcutsConflict: "Conflict — this shortcut is already in use",
  shortcutsReset: "Reset to Defaults",
  shortcutsSystem: "System",
  shortcutsCustom: "Custom",
  shortcutsEnabled: "Enabled",
  shortcutsDisabled: "Disabled",
  shortcutsAiSuggest: "Describe an action you want to shortcut...",
  shortcutsAiPlaceholder: "Type and press Enter — AI will suggest a shortcut",
  shortcutsKeyCombo: "Key Combo",
  shortcutsActionName: "Action Name",
  shortcutsScope: "Scope",
  shortcutsScopeGlobal: "Global",
  shortcutsScopeEditor: "Editor",
  shortcutsScopeCardBrowser: "Card Browser",
  shortcutsScopeTable: "Table",
  shortcutsReserved: "System",
  // Common widget strings
  allClear: "All clear",
  soon: "Soon",
  savedLocally: "saved locally",
  langFlag: "EN",
  // Weekly Planner
  weeklyPlanner: "Weekly Planner",
  weeklyPlannerDesc: "Weekly planning, daily tasks & recurring templates",
  plannerToday: "Today",
  plannerPersonal: "Mine",
  plannerTeam: "Team",
  plannerAll: "All",
  plannerTasks: "tasks",
  plannerUrgent: "urgent",
  plannerMeetings: "meetings",
  plannerMember: "Member",
  plannerTemplates: "Weekly Templates",
  plannerApply: "Apply",
  plannerFreeDay: "Free day 🎉",
  plannerAdd: "Add",
  plannerDone: "Done",
  plannerMoveToTomorrow: "Move to tomorrow",
  plannerDelete: "Delete",
  plannerNewTemplate: "New template name...",
  plannerCreate: "Create",
  plannerAddItem: "Add item",
  plannerNoItems: "No items. Add items to template.",
  plannerTaskPlaceholder: "Task + time...",
  plannerCancel: "Cancel",
  plannerAssignMe: "👤 Assign to me",
  plannerNone: "None",
  plannerMe: "me",
  plannerFree: "free",
  plannerTitlePlaceholder: "Title...",
  plannerApplyToWeek: "Apply to week",
  plannerTemplateDesc: "Create a weekly template with recurring tasks. Apply to the current week in one click.",
  plannerAddTask: "Add task",
  plannerPriorityUrgent: "Urgent",
  plannerPriorityImportant: "Important",
  plannerPriorityNormal: "Normal",
  plannerAddToTemplate: "Add item to template",
  // AppStore / Widget settings
  categoryAll: "All",
  selectWidgetToConfigure: "Select a widget to configure",
  widgetPlacement: "Placement",
  widgetSize: "Size",
  widgetActive: "Active",
  widgetComingSoon: "Coming Soon",
  widgetLocked: "Locked",
  widgetUnlocked: "Unlocked",
  // Search
  semanticResults: "Semantic Results",
  searchNavigate: "Navigate",
  searchSelect: "Select",
  searchClose: "Close",
  untitled: "Untitled",
  // Settings folder
  allSettings: "All Settings",
  storeSystem: "System",
  storeFolders: "Folders",
  storeCreateFolder: "Create Folder",
  storeActiveCount: "active",
  // Widget Store
  store: "Widget Store",
  storeSearch: "Search widgets...",
  storeTabInstalled: "Installed",
  storeTabAvailable: "Available",
  storeTabComingSoon: "Coming Soon",
  storeBack: "Back to store",
  storePlacement: "Placement",
  storeSystemWidget: "System widget — cannot be disabled.",
  storeNotifyMe: "Notify me",
  storeNoResults: "No widgets found",
  // Placements
  placementToolbar: "Toolbar",
  placementApps: "Apps",
  placementDisabled: "Disabled",
  placementDescToolbar: "Widget appears in the top bar and is always accessible.",
  placementDescApps: "Widget is active but only accessible through the Apps drawer.",
  placementDescDisabled: "Widget is completely off. No resources used.",
  // Categories
  categoryBasics: "Basics",
  categoryProductivity: "Productivity",
  categoryAiComms: "AI & Communications",
  categoryTeam: "Team",
  categoryAnalytics: "Analytics",
  categoryIntegrations: "Integrations",
  // Apps Drawer
  appsDrawer: "Apps",
  appsEmpty: "No apps here yet. Move widgets to 'Apps' in the Widget Store.",
  appsHint: "Widgets in Apps placement appear here.",
  // Custom Labels
  customLabel: "Custom Label",
  resetLabel: "Reset",
  // Profile Switcher
  profileSwitcher: "Profile Switcher",
  switchProfile: "Switch Profile",
  saveAsNew: "Save as new",
  profileName: "Profile name...",
  // Display Modes
  displayMode: "Display Mode",
  displayNormal: "Normal",
  displayCompact: "Compact",
  displayIconsOnly: "Icons Only",
  // Auto-Pack
  autoPack: "Auto-pack",
  // Panel Modes
  panelMode: "Panel Mode",
  panelModeDropdown: "Dropdown",
  panelModeSidePanel: "Side Panel",
  panelModePopup: "Popup",
  // Quick Bookmark
  quickBookmark: "Quick Bookmark",
  bookmarkAdded: "Bookmark added",
  openNote: "Open note",
  // KPI Widget
  kpiOpenProjects: "Open Projects",
  kpiDocuments: "Documents",
  kpiActivity7d: "Activity (7d)",
  kpiAvgHealth: "Avg Health",
  kpiQuickMetrics: "Quick Metrics",
  kpiBar: "KPIs",
  // Leads Pipeline Widget
  leadsPipeline: "Leads Pipeline",
  leadsPipelineDesc: "Sales pipeline stages — horizontal funnel view",
  leadsPipelineBar: "Leads",
  viewAllLeads: "View All Leads",
  activeLeads: "Active Leads",
  stageLead: "Lead",
  stageQualified: "Qualified",
  stageProposal: "Proposal",
  stageNegotiation: "Negotiation",
  stageClosedWon: "Closed Won",
  stageClosedLost: "Closed Lost",
  // Team Widget
  teamTitle: "Team",
  teamOnline: "online",
  teamBar: "online",
  // WATI Widget
  watiNoMessages: "No new messages",
  watiConfigNote: "Set NEXT_PUBLIC_WATI_URL for live connection",
  // External Links Widget
  externalLinksLabelPlaceholder: "Label",
  externalLinksCancel: "Cancel",
  externalLinksAdd: "Add",
  externalLinksAddLink: "Add Link",
  externalLinksReset: "Reset",
  externalLinksBar: "Links",
  // Today Widget
  todayLoading: "Loading...",
  todayNoEvents: "No events today.",
} as const;
export default widgets;
